export const RESET_PASSWORD_STATE = {
  LOADING: -1,
  SEND_VERIFY_CODE: 0,
  CHECK: 1,
  SET_NEW_PASSWORD: 2,
  SUCCESS: 3,
};
